import React, { useState } from 'react';
import { IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TableRow, TableCell } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { useDeleteCardOwnerMutation } from '../../../api/cardSlice';
import { Delete, Check, Close } from '@mui/icons-material';
import MobilePhoneStatus from '../../CustomComponents/MobilePhoneStatus';

function PhysicianRow(props) {
    const [isShowingDeleteConfirmation, setIsShowingDeleteConfirmation] = useState(false);
    const navigate = useNavigate();
    const { organizationId } = useParams();

    function handleDeleteClick(event) {
        event.stopPropagation();
        setIsShowingDeleteConfirmation(true);
    }

    const goToPhysician = (physician) => {
        navigate(`/superSettings/organizations/${organizationId}/physicians/${physician.id}`);
    }

    return (
        <TableRow 
            onClick={() => goToPhysician(props.physician)} 
            sx={{
                cursor: 'pointer',
                backgroundColor: props.physician.is_disabled ? '#f5f5f5' : 'inherit',
                opacity: props.physician.is_disabled ? 0.6 : 1,
                '&:hover': {
                    backgroundColor: props.physician.is_disabled ? '#e0e0e0' : 'rgba(0, 0, 0, 0.04)',
                },

            }}
        >
            <TableCell>{'Dr. ' + props.physician.last_name + ', ' + props.physician.first_name}</TableCell>
            <TableCell>{ props.physician.specialty}</TableCell>
            <TableCell>{ props.physician.count}</TableCell>
            <TableCell>{ props.physician.is_disabled ? 'Inactive' : 'Active'}</TableCell>
            <TableCell>{ props.physician.exclude_from_campaigns ? <Close /> : <Check />}</TableCell>
            <TableCell>
                <MobilePhoneStatus physician={props.physician} />
            </TableCell>
            <TableCell>
                <DeleteCardOwner open={isShowingDeleteConfirmation} setOpen={setIsShowingDeleteConfirmation} owner={props.physician} />
                <IconButton disabled={props.physician.is_disabled} onClick={(e) => handleDeleteClick(e)}>
                    <Delete />
                </IconButton>
            </TableCell>
        </TableRow>
    )
}

function DeleteCardOwner(props) {
    const [deleteCardOwner] = useDeleteCardOwnerMutation();

    function handleClose(e) {
        e.stopPropagation();
        props.setOpen(false);
    }

    const handleDelete = async(e) => {
        e.stopPropagation();
        await deleteCardOwner({
            cardOwner: props.owner,
        });
        handleClose(e);
    }

    return (
        <Dialog open={props.open} onClose={handleClose}>
            <DialogTitle>Confirm Card Owner Deletion</DialogTitle>
            <DialogContent>
                <DialogContentText>Are you sure you want to delete this card owner?</DialogContentText>
                <DialogContentText>
                    Deleting this physician will also delete their preference cards.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => handleClose(e)}>
                    Cancel
                </Button>
                <Button onClick={(e) => handleDelete(e)} style={{ color: 'red' }}>
                    Yes, delete
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default PhysicianRow;
